const moduleName = 'services.training';

let $inject = [
  "$http",
];

class TrainingService {
  constructor($http) {
    this.http = $http;
  }

  load_video_duration() {
    let handleSuccess = function (response) {
      if (!response.data || !response.data.success) {
        return [];
      }
      else {
        return response.data.data;
      }
    };

    let handleError = function (response) {
      return [];
    };

    return this.http
      .post("/app/pharmacist/load-video-duration")
      .then(handleSuccess, handleError);
  }

  auto_save_progress(watchedTime, handleSuccess, handleError) {
    return this.http
      .post("/app/pharmacist/progress-training-video", {
        video: {
          duration_watched: watchedTime,
        },
      })
      .then(handleSuccess, handleError);
  }

  complete_video(handleSuccess, handleError) {
    return this.http
      .post("/app/pharmacist/complete-training-video")
      .then(handleSuccess, handleError);
  }
}

TrainingService.$inject = $inject;

export default angular.module(moduleName, [])
  .service('TrainingService', TrainingService)
  .name;



/** WEBPACK FOOTER **
 ** D:/server/Apache24/htdocs/hmr/app/HMRX_App/scripts/src/services/training.service.js
 **/